import React from 'react';

export const additionalEvents = (
  <h3 className="vads-u-font-size--h5">Additional events or situations</h3>
);
